import React from "react";
import Style from "./questionItem.module.scss";
import { Icon } from "antd";
import { Multiple } from "./component/multiple";
import { Single } from "./component/single";
import { TextEditors } from "./component/editor";
import { Tiankong } from "./component/tiankong";
import { Cloze } from "./component/cloze";
import { Listening } from "./component/listening";
import { Reading } from "./component/reading";
import { TopicType } from "service/homework";
import ExamFileView from "../view";

interface IQuestionItemProps {
    item: TopicType;
    topicType: string;
    trunk: string;
    topicId: number;
    homeworkState: number;
    answers: any[];
    questionIndex?: number;
    contentText?: string | null;
    isRight?: string;
    canPastedText?: boolean;
    onQuestionChange: (
        topicId: number,
        topicType: string,
        answerId: number | number[],
        value?: string
    ) => void;
    topics?: TopicType[];
    score?: string;
}

const QuestionItem = ({
    item,
    score,
    trunk,
    topicType,
    answers,
    topicId,
    questionIndex,
    onQuestionChange,
    contentText,
    isRight,
    canPastedText = true,
    homeworkState = 1,
    topics = []
}: IQuestionItemProps) => {
    const handleChange = (answerId: number | number[], value?: string) => {};
    //题干
    const trunkFilter = trunk.replace(/<a.*?a>/g, "");
    //描述
    const contentTextFilter = contentText?.replace(/<a.*?a>/g, "");
    return (
        <div className={Style.main}>
            <div className={Style.question}>
                {questionIndex && (
                    <div className={Style.questionIndex}>{questionIndex}、</div>
                )}

                <div
                    className={Style.questionTrunk}
                    dangerouslySetInnerHTML={{ __html: trunkFilter }}
                />

                {/*题干附件预览*/}
                {item?.trunkFileList && item.trunkFileList?.length > 0 && (
                    <div className={Style.fileWrapper}>
                        {item.trunkFileList.map(listItem => (
                            <div key={listItem} className={Style.item}>
                                <ExamFileView
                                    src={listItem}
                                    key={listItem}
                                    officeUrl={
                                        item.trunkOfficeUrl ||
                                        item.officeUrl ||
                                        ""
                                    }
                                />
                            </div>
                        ))}
                    </div>
                )}

                {score && <div className={Style.score}> 本小题 {score} 分</div>}
                {isRight === "1" && (
                    <span className={Style.success}>
                        <Icon type="check" />
                        &nbsp;正确
                    </span>
                )}
                {isRight === "0" && (
                    <span className={Style.wrong}>
                        <Icon type="close" />
                        &nbsp;错误
                    </span>
                )}
            </div>

            <div className={Style.list}>
                {contentText && (
                    <>
                        <div
                            className={Style.questionTrunk}
                            dangerouslySetInnerHTML={{
                                __html: contentTextFilter || ""
                            }}
                        />
                        {/*主观题描述部分的附件预览*/}
                        {item?.fileList && item.fileList?.length > 0 && (
                            <div className={Style.fileWrapper}>
                                {item.fileList.map(listItem => (
                                    <div key={listItem} className={Style.item}>
                                        <ExamFileView
                                            src={listItem}
                                            key={listItem}
                                            officeUrl={
                                                item.officeUrl ||
                                                item.trunkOfficeUrl ||
                                                ""
                                            }
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                )}

                {(parseInt(topicType) === 1 || parseInt(topicType) === 3) && (
                    <Single
                        homeworkState={homeworkState}
                        list={answers}
                        onChange={handleChange}
                    />
                )}
                {parseInt(topicType) === 2 && (
                    <Multiple
                        homeworkState={homeworkState}
                        list={answers}
                        onChange={handleChange}
                    />
                )}
                {parseInt(topicType) === 4 && (
                    <TextEditors
                        canPastedText={canPastedText}
                        homeworkState={homeworkState}
                        list={answers}
                        onChange={handleChange}
                    />
                )}
                {parseInt(topicType) === 5 && (
                    <Tiankong
                        homeworkState={homeworkState}
                        list={answers}
                        onChange={handleChange}
                    />
                )}
                {parseInt(topicType) === 6 && (
                    <Listening
                        homeworkState={homeworkState}
                        topics={topics}
                        onQuestionChange={onQuestionChange}
                    />
                )}
                {parseInt(topicType) === 7 && (
                    <Cloze
                        homeworkState={homeworkState}
                        topics={topics}
                        onQuestionChange={onQuestionChange}
                    />
                )}
                {parseInt(topicType) === 8 && (
                    <Reading
                        homeworkState={homeworkState}
                        topics={topics}
                        onQuestionChange={onQuestionChange}
                    />
                )}
            </div>
        </div>
    );
};

export default QuestionItem;
